<template>
    <div class="flex items-center gap-2">
        <UInput type="number" size="lg" placeholder="Min" :model-value="filter.value?.min" @update:model-value="onUpdate('min', $event)" />
        <span class="text-gray-400">–</span>
        <UInput type="number" size="lg" placeholder="Max" :model-value="filter.value?.max" @update:model-value="onUpdate('max', $event)" />
    </div>
</template>

<script setup lang="ts">
import type { Filter } from '~/types/filter'

const emit = defineEmits<{ 'update:filter': [Filter] }>()
const props = defineProps<{ filter: Filter }>()

function onUpdate(which: 'min' | 'max', raw: string) {
    const n = raw === '' || raw == null ? undefined : Number(raw)
    const next = { ...(props.filter.value ?? {}), [which]: n }
    if (next.min != null && next.max != null && next.min > next.max) {
        if (which === 'min') next.max = next.min
        else next.min = next.max
    }
    if (next.min == null && next.max == null) {
        emit('update:filter', { ...props.filter, selected: undefined, value: undefined })
    } else {
        emit('update:filter', { ...props.filter, selected: next, value: next })
    }
}
</script>
